// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3lj1r","container":"styles_container__pISuV","title":"styles_title__1aEh4","wrapper":"styles_wrapper__3fB2N","answer":"styles_answer__2FCMb"};